(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-row"] && !Shopify.designMode) return;
  try {
    
  class BrandRowScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.brand-row__track');
      this.prevButton = this.querySelector('[data-brand-row-prev]');
      this.nextButton = this.querySelector('[data-brand-row-next]');
      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.updateArrows = this.updateArrows.bind(this);

      this.track.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows);

      this.prevButton.addEventListener('click', () => {
        this.track.scrollBy({ left: -this.track.clientWidth * 0.8, behavior: 'smooth' });
      });

      this.nextButton.addEventListener('click', () => {
        this.track.scrollBy({ left: this.track.clientWidth * 0.8, behavior: 'smooth' });
      });

      this.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', this.updateArrows, { once: true });
      });

      this.updateArrows();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows);
    }

    updateArrows() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 4;
      const atStart = this.track.scrollLeft <= 4;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;

      this.prevButton.hidden = !hasOverflow || atStart;
      this.nextButton.hidden = !hasOverflow || atEnd;
    }
  }

  if (!customElements.get('brand-row')) {
    customElements.define('brand-row', BrandRowScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  class CompleteTheLook extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.arrows = this.querySelector('[data-arrows]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.modal = this.querySelector('[data-modal]');
      this.slides = this.querySelectorAll('[data-slide]');
      this.itemLists = this.querySelectorAll('[data-items]');
      this.counter = this.querySelector('[data-counter]');
      this.panel = this.querySelector('[data-panel]');
      this.current = 0;

      this.updateArrows = this.updateArrows.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.querySelectorAll('.ctl__image').forEach((image) => this.watchImage(image));

      this.prevButton.addEventListener('click', () => this.scrollTrack(-1));
      this.nextButton.addEventListener('click', () => this.scrollTrack(1));
      this.track.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows);
      this.updateArrows();

      this.querySelectorAll('[data-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => this.toggleHotspots(toggle));
      });

      this.querySelectorAll('[data-dot]').forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.stopPropagation();
          this.togglePop(dot);
        });
      });
      document.addEventListener('click', this.onDocumentClick);

      this.querySelectorAll('[data-open]').forEach((button) => {
        button.addEventListener('click', () => this.openModal(Number(button.dataset.open)));
      });

      const modalPrev = this.querySelector('[data-modal-prev]');
      const modalNext = this.querySelector('[data-modal-next]');
      if (modalPrev) modalPrev.addEventListener('click', () => this.showLook(this.current - 1));
      if (modalNext) modalNext.addEventListener('click', () => this.showLook(this.current + 1));

      this.querySelector('[data-close]').addEventListener('click', () => this.modal.close());

      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) this.modal.close();
      });

      this.modal.addEventListener('keydown', (event) => {
        if (this.slides.length < 2) return;
        if (event.key === 'ArrowLeft') this.showLook(this.current - 1);
        if (event.key === 'ArrowRight') this.showLook(this.current + 1);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows);
      document.removeEventListener('click', this.onDocumentClick);
    }

    // A look image that fails to load is retried once, then its card is hidden
    // so the carousel never shows an empty grey block.
    watchImage(image) {
      const onError = () => {
        if (!image.dataset.retried) {
          image.dataset.retried = 'true';
          const bust = (url) => url.replace(/(\?|&)retry=\d+/, '') + (url.includes('?') ? '&' : '?') + 'retry=' + Date.now();
          setTimeout(() => {
            if (image.srcset) {
              image.srcset = image.srcset
                .split(',')
                .map((candidate) => {
                  const [url, size] = candidate.trim().split(/\s+/);
                  return bust(url) + (size ? ' ' + size : '');
                })
                .join(', ');
            }
            image.src = bust(image.src);
          }, 800);
          return;
        }
        const card = image.closest('.ctl__card');
        if (card) card.hidden = true;
        this.updateArrows();
      };

      image.addEventListener('error', onError);
      if (image.complete && image.naturalWidth === 0 && image.currentSrc) onError();
    }

    scrollTrack(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.offsetWidth + gap) });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.arrows.hidden = maxScroll <= 1;
      this.prevButton.disabled = this.track.scrollLeft <= 1;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
    }

    toggleHotspots(toggle) {
      const card = toggle.closest('[data-card]');
      const isShowing = card.classList.toggle('is-showing-items');
      toggle.setAttribute('aria-pressed', String(isShowing));
      toggle.textContent = isShowing ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
      if (!isShowing) this.closePops();
    }

    togglePop(dot) {
      const pop = dot.nextElementSibling;
      const willOpen = pop.hidden;
      this.closePops();
      if (willOpen) {
        pop.hidden = false;
        dot.setAttribute('aria-expanded', 'true');
      }
    }

    closePops() {
      this.querySelectorAll('[data-pop]').forEach((pop) => {
        pop.hidden = true;
        pop.previousElementSibling.setAttribute('aria-expanded', 'false');
      });
    }

    onDocumentClick(event) {
      if (!event.target.closest('[data-pop]')) this.closePops();
    }

    openModal(index) {
      this.closePops();
      this.showLook(index);
      this.modal.showModal();
    }

    showLook(index) {
      const total = this.slides.length;
      this.current = (index + total) % total;

      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== this.current;
      });
      this.itemLists.forEach((list, listIndex) => {
        list.hidden = listIndex !== this.current;
      });

      if (this.counter) this.counter.textContent = this.current + 1 + '/' + total;
      this.panel.scrollTop = 0;
    }
  }

  if (!customElements.get('complete-the-look')) {
    customElements.define('complete-the-look', CompleteTheLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      class StickyHeader extends HTMLElement {
        connectedCallback() {
          this.ticking = false;
          this.handleScroll = this.handleScroll.bind(this);
          this.handleDocumentClick = this.handleDocumentClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);

          window.addEventListener('scroll', this.handleScroll, { passive: true });
          document.addEventListener('click', this.handleDocumentClick);
          document.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('click', (event) => {
            if (event.target.closest('.mobile-menu__close')) {
              const details = event.target.closest('details');
              if (details) details.removeAttribute('open');
            }
          });

          this.handleScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.handleScroll);
          document.removeEventListener('click', this.handleDocumentClick);
          document.removeEventListener('keydown', this.handleKeydown);
        }

        handleScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.classList.toggle('is-scrolled', window.scrollY > 8);
            this.ticking = false;
          });
        }

        handleDocumentClick(event) {
          this.querySelectorAll('details[open]').forEach((details) => {
            if (!details.contains(event.target)) details.removeAttribute('open');
          });
        }

        handleKeydown(event) {
          if (event.key !== 'Escape') return;
          this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-choreography"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-scroll-choreography]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var POSITION_STOPS = [0, 0.3, 0.35, 0.65, 1];
    var OPACITY_STOPS = [0, 0.75, 0.85, 1];

    /*
     * The choreography (swap / converge / grow) plays out over the first
     * CHOREO_END share of the section's scrollable distance. The remaining
     * share is a static "dwell" — the fullscreen image holds still while
     * the hero text fades in, like a normal hero, before the section
     * finally scrolls away.
     */
    var CHOREO_END = 0.7;

    /*
     * The top-right block cross-fades from its own image to `image_reveal`
     * during phase 2, finishing no later than progress 0.65 (same as the
     * convergence phase).
     */
    var CROSSFADE_STOPS = [0, 0.35, 0.65, 1];
    var CROSSFADE_ORIGINAL = [1, 1, 0, 0];
    var CROSSFADE_REVEAL = [0, 0, 1, 1];

    var KEYFRAMES = {
      'top-left': {
        x: [-20, -20, -20, 0, 0],
        y: [-14, 14, 14, 0, 0],
        opacity: [1, 1, 0, 0]
      },
      'top-right': {
        x: [20, 20, 20, 0, 0],
        y: [-14, -14, -14, 0, 0],
        width: [36, 36, 36, 36, 100],
        height: [24, 24, 24, 24, 100],
        radius: [20, 20, 20, 20, 0],
        opacity: [1, 1, 1, 1]
      },
      'bottom-left': {
        x: [-20, -20, -20, 0, 0],
        y: [14, 14, 14, 0, 0],
        opacity: [1, 1, 0, 0]
      },
      'bottom-right': {
        x: [20, 20, 20, 0, 0],
        y: [14, -14, -14, 0, 0],
        opacity: [1, 1, 0, 0]
      }
    };

    function interpolate(value, inputRange, outputRange) {
      var last = inputRange.length - 1;

      if (value <= inputRange[0]) return outputRange[0];
      if (value >= inputRange[last]) return outputRange[last];

      for (var i = 0; i < last; i++) {
        var start = inputRange[i];
        var end = inputRange[i + 1];

        if (value >= start && value <= end) {
          var t = end === start ? 0 : (value - start) / (end - start);
          return outputRange[i] + t * (outputRange[i + 1] - outputRange[i]);
        }
      }

      return outputRange[last];
    }

    sections.forEach(function (root) {
      var sticky = root.querySelector('.scroll-choreography__sticky');
      var overlay = root.querySelector('[data-scroll-choreography-overlay]');
      var heroText = root.querySelector('[data-scroll-choreography-hero-text]');
      var images = {
        'top-left': root.querySelector('[data-scroll-choreography-image="top-left"]'),
        'top-right': root.querySelector('[data-scroll-choreography-image="top-right"]'),
        'bottom-left': root.querySelector('[data-scroll-choreography-image="bottom-left"]'),
        'bottom-right': root.querySelector('[data-scroll-choreography-image="bottom-right"]')
      };
      var topRightOriginal = root.querySelector('[data-scroll-choreography-layer="original"]');
      var topRightReveal = root.querySelector('[data-scroll-choreography-layer="reveal"]');

      var ticking = false;

      function computeRawProgress() {
        var rect = root.getBoundingClientRect();
        var total = rect.height - window.innerHeight;

        if (total <= 0) {
          return rect.top <= 0 ? 1 : 0;
        }

        var scrolled = -rect.top;
        return Math.min(1, Math.max(0, scrolled / total));
      }

      function render() {
        ticking = false;

        var rawProgress = computeRawProgress();
        var choreoProgress = Math.min(1, rawProgress / CHOREO_END);
        var textProgress = Math.min(1, Math.max(0, (rawProgress - CHOREO_END) / (1 - CHOREO_END)));

        Object.keys(images).forEach(function (key) {
          var el = images[key];
          if (!el) return;

          var kf = KEYFRAMES[key];
          var x = interpolate(choreoProgress, POSITION_STOPS, kf.x);
          var y = interpolate(choreoProgress, POSITION_STOPS, kf.y);
          var opacity = interpolate(choreoProgress, OPACITY_STOPS, kf.opacity);

          el.style.transform = 'translate(-50%, -50%) translate(' + x + 'vw, ' + y + 'vh)';
          el.style.opacity = String(opacity);

          if (kf.width && kf.height) {
            var width = interpolate(choreoProgress, POSITION_STOPS, kf.width);
            var height = interpolate(choreoProgress, POSITION_STOPS, kf.height);
            el.style.width = width + 'vw';
            el.style.height = height + 'vh';
          }

          if (kf.radius) {
            var radius = interpolate(choreoProgress, POSITION_STOPS, kf.radius);
            el.style.borderRadius = radius + 'px';
          }
        });

        if (topRightOriginal && topRightReveal) {
          var originalOpacity = interpolate(choreoProgress, CROSSFADE_STOPS, CROSSFADE_ORIGINAL);
          topRightOriginal.style.opacity = String(originalOpacity);
          topRightReveal.style.opacity = String(interpolate(choreoProgress, CROSSFADE_STOPS, CROSSFADE_REVEAL));
          /* Once image_reveal has taken over, the (now invisible) original's
             product link must stop intercepting clicks meant for the hero. */
          topRightOriginal.style.pointerEvents = originalOpacity > 0 ? 'auto' : 'none';
        }

        if (overlay) {
          overlay.style.opacity = String(textProgress);
        }

        if (heroText) {
          heroText.style.opacity = String(textProgress);
          heroText.style.transform = 'translateY(' + (1 - textProgress) * 18 + 'px)';
          heroText.style.pointerEvents = textProgress > 0.5 ? 'auto' : 'none';
        }
      }

      function requestTick() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(render);
        }
      }

      render();

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
